import { CommandsBase } from './base';
import { Boards } from 'src/api';

export namespace BatchActions {
  export namespace Types {
    export type BatchActionOperation = 'validate' | 'deliver';

    export enum BatchActionName {
      VALIDATE = 'validate',
      DELIVER = 'deliver',
    }

    export interface BatchAction {
      action: BatchActionOperation;
      boardId: number;
    }

    export interface BoardBatchActionOperationResult {
      id: number;
      arn: string;
      type: BatchActionOperation;
      ok: boolean;
      done: boolean;
    }

    export interface BatchActionExecutionRecord {
      executionArn: string;
      id: string;
      type: string;
      error: number;
      errorMessage?: string;
      results: {
        [BOARD_ID: string]: {
          [ACTION: string]: BoardBatchActionOperationResult;
        };
      };
      stateMachineArn: string;
      status: 'init' | 'validate' | 'deliver' | 'done';
      ttl: number;
      tasks: BatchAction[];
      timestamp: string;
    }

    export interface BatchActionTriggerProps {
      actions: BatchAction[];
    }

    export interface ActionTriggerResponse {
      executionArn: string;
      startDate: string;
    }

    export interface BatchActionTask {
      action: BatchActionOperation;
      board: Boards.Types.Board;
    }

    export interface BatchActionExecutionsProps {
      period: number;
      limit?: number;
    }

    export type BatchActionExecutionsResponse = BatchActionExecutionRecord[];

    export interface BatchActionAbortProps {
      executionArn: string;
      timestamp: string;
    }

    export interface BatchActionAbortResponse {
      stopDate: string;
    }

    export interface BatchActionExecution {
      execution: ActionTriggerResponse;
      actions: BatchActionTask[];
    }
  }

  export const SERVICE = 'batchActions'; // not used yet

  export const ACTIONS = {
    getActive: 'list', // todo: rename to getActive
    trigger: 'trigger',
    abort: 'abort',
  };

  export const SKIP_EVENTS = [ACTIONS.trigger, ACTIONS.abort];

  export class Commands extends CommandsBase {
    trigger(props: Types.BatchActionTriggerProps) {
      return this.client.execute<
        Types.BatchActionTriggerProps,
        Types.ActionTriggerResponse
      >(this.command(ACTIONS.trigger), props);
    }

    getActive(props: Types.BatchActionExecutionsProps) {
      return this.client.execute<
        Types.BatchActionExecutionsProps,
        Types.BatchActionExecutionsResponse
      >(this.command(ACTIONS.getActive), props);
    }

    abort(props: Types.BatchActionAbortProps) {
      return this.client.execute<
        Types.BatchActionAbortProps,
        Types.BatchActionAbortResponse
      >(this.command(ACTIONS.abort), props);
    }
  }
}
